"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ApptInfo_1 = __importDefault(require("./ApptInfo"));
exports.default = ApptInfo_1.default;
//# sourceMappingURL=index.js.map